export const SIGNATURE = "dlalwlqmftycmdnjrtm";
export const ADMIN_ACCOUNT = "administrator@shortsworks.io";
export const CAFE24_CLIENT_ID = "5ckpSeqTEC5DNVyrORMk7E";
